export const loanStatuses = [
	{ code: "closed", name: "Closed" },
	{ code: "running", name: "Running" },
	{ code: "none", name: "None" },
];

export const banks = [
	{ code: "abuDhabiCommercialBankLtd", name: "Abu Dhabi Commercial Bank Ltd" },
	{ code: "aBBankLtd", name: "AB Bank Ltd" },
	{ code: "ahmedabadMercantileCo-opBank", name: "Ahmedabad Mercantile Co-op Bank" },
	{ code: "allahabadBank", name: "Allahabad Bank" },
	{ code: "andhraBank", name: "Andhra Bank" },
	{ code: "antwerpDiamondBankMumbai", name: "Antwerp Diamond Bank Mumbai" },
	{ code: "axisBank", name: "Axis Bank" },
	{ code: "bajajFinserv", name: "Bajaj Finserv" },
	{ code: "bankOfAmerica", name: "Bank Of America" },
	{ code: "bankOfBaroda", name: "Bank of Baroda" },
	{ code: "bankOfCeylon", name: "Bank Of Ceylon" },
	{ code: "bankOfIndia", name: "Bank of India" },
	{ code: "bankOfMaharashtra", name: "Bank Of Maharashtra" },
	{ code: "bankOfNovaScotia", name: "Bank Of Nova Scotia" },
	{ code: "bankOfTokyo-MitsubishiUfjLtd", name: "Bank Of Tokyo-Mitsubishi Ufj Ltd" },
	{ code: "bankInternasionalIndonesia", name: "Bank Internasional Indonesia" },
	{ code: "barclaysBankPlc", name: "Barclays Bank Plc" },
	{ code: "bharatCo-opBank(Mumbai)Ltd", name: "Bharat Co-op Bank (Mumbai) Ltd" },
	{ code: "bNPParibas", name: "BNP Paribas" },
	{ code: "canaraBank", name: "Canara Bank" },
	{ code: "canFinHomes", name: "Can Fin Homes" },
	{ code: "catholicSyrianBankLtd", name: "Catholic Syrian Bank Ltd" },
	{ code: "centralBankofIndia", name: "Central Bank of India" },
	{ code: "chinatrustCommercialBank", name: "Chinatrust Commercial Bank" },
	{ code: "citibankIndia", name: "Citibank India" },
	{ code: "citizencreditCo-opBankLtd", name: "Citizencredit Co-op Bank Ltd" },
	{ code: "cityUnionBankLtd", name: "City Union Bank Ltd" },
	{ code: "corporationBank", name: "Corporation Bank" },
	{ code: "cosmosCo-opBankLtd", name: "Cosmos Co-op Bank Ltd" },
	{ code: "creditAgricoleCorpandInvestmentBank", name: "Credit Agricole Corp and Investment Bank" },
	{ code: "commonwealthBankofAustralia", name: "Commonwealth Bank of Australia" },
	{ code: "dBSBank", name: "DBS Bank" },
	{ code: "denaBank", name: "Dena Bank" },
	{ code: "deutscheBankAg", name: "Deutsche Bank Ag" },
	{ code: "developmentCreditBank", name: "Development Credit Bank" },
	{ code: "dhanlaxmiBankLtd", name: "Dhanlaxmi Bank Ltd" },
	{ code: "dhfl", name: "DHFL" },
	{ code: "federalBankLtd", name: "Federal Bank Ltd" },
	{ code: "firstrandBankLtd", name: "Firstrand Bank Ltd" },
	{ code: "godrejHousingFinanceLimited", name: "Godrej Housing Finance Limited (GHFL)" },
	{ code: "greaterBombayCo-opBankLtd", name: "Greater Bombay Co-op Bank Ltd" },
	{ code: "hindujaHousingFinance", name: "Hinduja Housing Finance" },
	{ code: "hDFCBank", name: "HDFC Bank" },
	{ code: "hSBC", name: "HSBC" },
	{ code: "iCICIBank", name: "ICICI Bank" },
	{ code: "iDBIBank", name: "IDBI Bank" },
	{ code: "iDFC", name: "IDFC First Bank" },
	{ code: "iIFL", name: "IIFL - India Infoline" },
	{ code: "indiaBulls", name: "India Bulls" },
	{ code: "indianBank", name: "Indian Bank" },
	{ code: "indianOverseasBank", name: "Indian Overseas Bank" },
	{ code: "indusIndBankLtd", name: "IndusInd Bank Ltd" },
	{ code: "iNGVysyaBank", name: "ING Vysya Bank" },
	{ code: "karnatakBankLtd", name: "Karnataka Bank Ltd." },
	{ code: "karnatakaStateCo-opApexBank", name: "Karnataka State Co-op Apex Bank" },
	{ code: "karurVysyaBank", name: "Karur Vysya Bank" },
	{ code: "kotakMahindraBank", name: "Kotak Mahindra Bank" },
	{ code: "lakshmiVilasBankLtd", name: "Lakshmi Vilas Bank Ltd" },
	{ code: "licHousingFinance", name: "LIC Housing Finance" },
	{ code: "lntFinance", name: "L & T Finance (LNT, L&T)" },
	{ code: "nationalBankLtd", name: "Nainital Bank Ltd" },
	{ code: "orientalBank", name: "Oriental Bank of Commerce" },
	{ code: "punjabNationalBank", name: "Punjab National Bank" },
	{ code: "punjabSindBank", name: "Punjab Sind Bank" },
	{ code: "relianceCapital", name: "Reliance Capital" },
	{ code: "repcoBank", name: "Repco Bank" },
	{ code: "reserveBankOfIndia", name: "Reserve Bank Of India" },
	{ code: "sirMVisvesvarayaCo-opBankLtd", name: "Sir M. Visvesvaraya Co-operative Bank Ltd" },
	{ code: "stateBankOfHydrabad", name: "State Bank of Hyderabad" },
	{ code: "stateBankOfIndia", name: "State Bank of India" },
	{ code: "stateBankOfMysore", name: "State Bank of Mysore" },
	{ code: "stateBankOfPatiala", name: "State Bank Of Patiala" },
	{ code: "stateBankOfTravancore", name: "State Bank Of Travancore" },
	{ code: "stateBankOfSaurashtra", name: "State Bank of Saurashtra" },
	{ code: "syndicateBank", name: "Syndicate Bank" },
	{ code: "standardChartered", name: "Standard Chartered Bank" },
	{ code: "sundaramHomeFinance", name: "Sundaram Home Finance" },
	{ code: "tataFinance", name: "Tata Capital Finance" },
	{ code: "ucoBank", name: "UCO Bank" },
	{ code: "unionBankOfIndia", name: "Union Bank of India" },
	{ code: "unitedOverseasBank", name: "United Overseas Bank" },
	{ code: "vijayBank", name: "Vijaya Bank" },
	{ code: "yesBank", name: "Yes Bank" },
];
